import { ChangeDetectorRef, Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentProvider } from 'src/app/common';
import { PaymentService } from 'src/app/services/payment.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-payment-check',
  templateUrl: './payment-check.component.html',
  styleUrls: ['./payment-check.component.scss']
})
export class PaymentCheckComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private paymentService: PaymentService,
    private spinner: SpinnerService, private changeDetectorRef: ChangeDetectorRef) { }
  PaymentProvider = PaymentProvider;
  payment: any;
  @Input('no-manual') noManual: boolean;
  @ContentChild('reason') reasonTemplate: TemplateRef<any>;
  @ContentChild('reasonInformation') reasonInformationTemplate: TemplateRef<any>;
  @ContentChild('reasonExpensive') reasonExpensiveTemplate: TemplateRef<any>;

  hidePayment: boolean;
  async ngOnInit() {
    await this.loadPayment();
    this.route.queryParams.subscribe(async () => await this.loadPayment());
  }

  failedReason: string;
  async loadPayment() {
    const pid = this.route.snapshot.queryParams['pid'];
    if (!pid) return;
    this.payment = await this.paymentService.get(pid);
    this.loaded.emit(this.payment);
    this.changeDetectorRef.markForCheck();
  }

  async retry(changeProvider = false) {
    if (this.payment) {
      this.spinner.show();
      this.paymentService.retry(this.payment.Id, changeProvider);
    }
  }

  @Output() loaded = new EventEmitter();
  @Output() closed = new EventEmitter();
  close() {
    this.hidePayment = true;
    this.router.navigate([], {
      queryParams: { 'pid': null },
      queryParamsHandling: 'merge'
    }).then(() => this.closed.emit());
  }

  retryManual(manualToken: string) {
    this.paymentService.retry(this.payment.Id, false, manualToken);
  }
}
